import React from "react";
import FavoritesView from "./Views/FavoritesView";
import { observer } from "mobx-react-lite";

const FavoritesPresenter = observer(({ model }) => {
  const favorites = model.getFavorites();

  function handleRemove(item, type) {
    model.removeFavorite(item, type);
  }

  return (
    <>
      <FavoritesView favorites={favorites} onRemove={handleRemove} />
    </>
  );
});

export default FavoritesPresenter;